import styled from '@emotion/styled';
import { colors } from '@innovationdepartment/proxima-ui';

export const CastingProfileLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 960px;
`;

export const FormSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px;
  border: 1px solid ${colors.neutral20};
  border-radius: 8px;
  background-color: ${colors.white};
`;

export const FieldRow = styled.div`
  display: flex;
  gap: 16px;

  > * {
    flex: 1;
  }
`;

export const ErrorText = styled.span`
  color: ${colors.red50};
  font-size: 12px;
`;

export const SelectedChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const SectionHeading = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

/* The preferred/avoid distinction has to read at a glance, so the tabs get
   larger, bolder labels and a baseline border marking them as a tab strip */
export const TagTabsWrapper = styled.div`
  /* Match FormSection's 12px heading gap — this wrapper sits inside
     CastingTagTabs' own div, outside the section's flex gap */
  margin-top: 12px;

  .MuiTabs-root {
    border-bottom: 1px solid ${colors.neutral20};
  }

  .MuiTab-root {
    font-size: 16px;
    font-weight: 700;
  }

  .MuiTabs-indicator {
    height: 3px;
  }
`;

export const TabPanel = styled.div`
  margin-top: 16px;

  &[hidden] {
    display: none;
  }
`;

export const CategorySection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
`;

export const SaveBar = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
`;

export const CenteredState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 64px 0;
`;
